/** Pinterest-style save mark. */
export function BookmarkIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path d="M6.5 3.5h11v17l-5.5-3.8-5.5 3.8z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
